import React from 'react';
import { COLORS, SPACING, BORDER_RADIUS } from '../../utils/constants';

function RoomErrorModal({ roomId, onReturnHome }) {
  const containerStyle = {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: COLORS.background,
    padding: SPACING.xl,
  };

  const contentStyle = {
    maxWidth: '600px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  };

  const headingStyle = {
    fontSize: '24px',
    fontWeight: '400',
    color: COLORS.text,
    marginBottom: SPACING.lg,
    lineHeight: '1.5',
  };

  const instructionStyle = {
    fontSize: '14px',
    color: COLORS.textSecondary,
    marginBottom: SPACING.xxl,
    lineHeight: '1.6',
  };

  const urlExampleStyle = {
    fontSize: '14px',
    color: COLORS.primary,
    marginBottom: SPACING.md,
    wordBreak: 'break-all',
  };

  const learnMoreLinkStyle = {
    fontSize: '14px',
    color: COLORS.primary,
    textDecoration: 'none',
    cursor: 'pointer',
    border: `1px solid ${COLORS.primary}`,
    borderRadius: BORDER_RADIUS.sm,
    padding: '2px 8px',
    display: 'inline-block',
    marginBottom: SPACING.xxl,
  };

  const returnButtonStyle = {
    padding: `${SPACING.md} ${SPACING.xxl}`,
    background: COLORS.primary,
    color: COLORS.background,
    border: 'none',
    borderRadius: BORDER_RADIUS.md,
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    marginBottom: SPACING.md,
    transition: 'background 0.2s ease',
  };

  const feedbackLinkStyle = {
    fontSize: '14px',
    color: COLORS.primary,
    textDecoration: 'none',
    cursor: 'pointer',
    marginBottom: SPACING.xxxl,
  };

  const infoBoxStyle = {
    width: '100%',
    maxWidth: '500px',
    border: `1px solid ${COLORS.border}`,
    borderRadius: BORDER_RADIUS.md,
    padding: SPACING.lg,
    display: 'flex',
    alignItems: 'flex-start',
    gap: SPACING.md,
    background: COLORS.backgroundGrey,
  };

  const shieldIconStyle = {
    width: '24px',
    height: '24px',
    flexShrink: 0,
    marginTop: '2px',
  };

  const infoTextStyle = {
    flex: 1,
    textAlign: 'left',
  };

  const infoTitleStyle = {
    fontSize: '14px',
    fontWeight: '500',
    color: COLORS.text,
    marginBottom: SPACING.xs,
  };

  const infoDescriptionStyle = {
    fontSize: '13px',
    color: COLORS.textSecondary,
    lineHeight: '1.5',
  };

  const handleReturnClick = (e) => {
    e.preventDefault();
    onReturnHome();
  };

  const handleLearnMoreClick = (e) => {
    e.preventDefault();
    // Could open a help page or modal
  };

  const exampleUrl = `${window.location.origin}/team/xxx-yyyy-zzz`;

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <h1 style={headingStyle}>Check your meeting code.</h1>
        <p style={instructionStyle}>
          Make sure you entered the correct meeting code in the URL, for example:
        </p>
        <div style={urlExampleStyle}>{exampleUrl}</div>
        <a
          href="#"
          onClick={handleLearnMoreClick}
          style={learnMoreLinkStyle}
          onMouseEnter={(e) => e.target.style.background = COLORS.backgroundGrey}
          onMouseLeave={(e) => e.target.style.background = 'transparent'}
        >
          Learn more
        </a>
        
        <button
          onClick={handleReturnClick}
          style={returnButtonStyle}
          onMouseEnter={(e) => e.target.style.background = COLORS.primaryDark}
          onMouseLeave={(e) => e.target.style.background = COLORS.primary}
        >
          Return to home screen
        </button>
        
        <a
          href="#"
          onClick={(e) => e.preventDefault()}
          style={feedbackLinkStyle}
          onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
          onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
        >
          Submit feedback
        </a>

        <div style={infoBoxStyle}>
          <svg style={shieldIconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L4 5V11C4 16.55 7.16 21.74 12 23C16.84 21.74 20 16.55 20 11V5L12 2Z" fill={COLORS.primary} stroke={COLORS.primary} strokeWidth="1.5"/>
            <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <div style={infoTextStyle}>
            <div style={infoTitleStyle}>Your meeting is safe</div>
            <div style={infoDescriptionStyle}>
              No one can join a meeting unless invited or admitted by the host.
            </div>
          </div>
          <a
            href="#"
            onClick={handleLearnMoreClick}
            style={{
              fontSize: '14px',
              color: COLORS.primary,
              textDecoration: 'none',
              cursor: 'pointer',
              alignSelf: 'flex-start',
              marginTop: SPACING.xs,
            }}
            onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
            onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
          >
            Learn more
          </a>
        </div>
      </div>
    </div>
  );
}

export default RoomErrorModal;

